module.exports = __webpack_public_path__ + "statics/img/cate2-2@2x.e418a153.png";